/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import productType from './modules/productType'
import product from './modules/product'
import order from './modules/order'
import delivery from './modules/delivery'
import fiscal from './modules/fiscal/fiscal'
import ratings from './modules/Ratings'
import notifications from './modules/notifications'
import coupons from './modules/coupons'
import taxes from './modules/taxes'
import fiscalReports from './modules/fiscal/reports'
import tables from './modules/tables'
import menus from './modules/menus'
import payment from './modules/payment'
import bill from './modules/bill'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: { productType, product, order, delivery, ratings, notifications, coupons, taxes, fiscal, fiscalReports, tables, menus, payment, bill },
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production'
})
